import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoBaseCardContainer,
    RaikoTableTitleContainer,
    RaikoCustomTable,
    showErrorMessage,
    RaikoDefaultDialogPage,
    DialogSize
} from "@moeindal/base-raiko-panel-components"
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {FeaturesService} from "../../serverService/featuresService/FeaturesService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import AddNewFeature from "./AddNewFeature";
import {addNewRowToTable} from "../../util/TableProvider";
import {useNavigate} from "react-router-dom";

export default function Features() {


    const [numberOfItems, setNumberOfItems] = useState(0)
    const [featuresData, setFeaturesData] = useState([])
    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0)
    const [page, setPage] = useState(0)
    let size = 20;

    const service = new FeaturesService()
    useEffect(() => {
        if (typeof service !== 'undefined') {
            getFeaturesLiatFromServer()
        }
    }, []);

    function tableFeaturesPreparation(id, number, title, createdBy) {
        return {
            id: id,
            number: number,
            title: title,
            createdBy: createdBy
        }

    }


    function getFeaturesLiatFromServer() {
        setTableLoading(true)
        service.getFeaturesLiat(page, size).then(
            response => {
                setNumberOfItems(response.numberOfItems)
                setPageCount(response.totalPage)
                setFeaturesData([])
                response.data.map((item, index) => {
                    setFeaturesData((prevState => [
                        ...prevState,
                        tableFeaturesPreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.createdBy
                        )
                    ]))
                })
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    function handleChangePage(newPage) {
        setPage(newPage)
        getFeaturesLiatFromServer()
    }

    const [openDialog, setOpenDialog] = useState(false)

    function handleOpenDialog() {
        setOpenDialog(true)
    }

    function handleCloseDialog() {
        setOpenDialog(false)
    }

    function handlePushNewFeatureToTable(item) {
        const newItems = addNewRowToTable(
            tableFeaturesPreparation(
                item.id,
                1,
                item.title,
                item.createdBy,
                item
            ),
            featuresData
        )
        setFeaturesData(newItems)
        handleCloseDialog()
    }

    const navigate = useNavigate()

    function showFeatureDetail(rowId) {
        navigate(RouteHelper.FeatureDetail.globalUrl.replace(":id", rowId))
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.Features.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                pageTitle={"افزودن ویژگی جدید"}
                onClose={handleCloseDialog}
                dialogSize={DialogSize.MEDIUM}
                open={openDialog}
            >
                <AddNewFeature handlePushNewFeatureToTable={handlePushNewFeatureToTable}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(RouteHelper.Features.name, "")
                        ]}
                    />
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"ویژگی ها"}
                                amount={numberOfItems}
                                hasCreateNewItem
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                header={featuresTableColumn}
                                data={featuresData}
                                isLoading={tableLoading}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePage}
                                rowClicked={showFeatureDetail}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

const featuresTableColumn = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'title',
        label: 'عنوان',
    },
    {
        id: 'createdBy',
        label: 'سازنده',
    },
]